import * as api from '@/api'
import Vue from 'vue'

export default {
  state: {
    unruly: [],
    loadingUnrulyPax: false,
    currentUnrulyPage: 0,
    totalUnrulyCount: 0,
    totalUnrulyPages: 0,
    unrulyPaxListPagination: {
      descending: true,
      page: 1,
      rowsPerPage: 15,
      totalItems: 0,
      rowsPerPageItems: [15, 30]
    }
  },
  getters: {
    unrulyPaxListPagination: state => state.unrulyPaxListPagination,
    unruly: state => state.unruly,
    loadingUnrulyPax: state => state.loadingUnrulyPax
  },
  mutations: {
    setUnrulyPaxListPagination(state, value) {
      state.unrulyPaxListPagination = value
    },
    setLoadingUnrulyPax(state, value) {
      state.loadingUnrulyPax = value
    },
    setCurrentUnrulyPage(state, value) {
      state.currentUnrulyPage = value
    },
    setTotalUnrulyCount(state, value) {
      state.totalUnrulyCount = value
    },
    setTotalUnrulyPages(state, value) {
      state.totalUnrulyPages = value
    },
    saveUnrulyPax(state, unruly) {
      state.unruly = unruly
      Vue.set(state.unrulyPaxListPagination, 'totalItems', state.totalUnrulyCount)
    }
  },
  actions: {
    getUnrulyPax({ commit, state, getters }, payload) {
      commit('setLoadingUnrulyPax', true)
      commit('setCurrentUnrulyPage', payload.page)
      api.getUnrulyPax(payload)
        .then(response => {
          if (response) {
            commit('setTotalUnrulyCount', response.data.totalCount)
            commit('setTotalUnrulyPages', response.data.totalPages)
            commit('saveUnrulyPax', response.data.unrulyPaxOutputLists)
          }
        })
        .finally(() => {
          commit('setLoadingUnrulyPax', false)
        })
    },
    uploadUnrulyPax({ commit, rootGetters }, archiveFile) {
      return new Promise((resolve, reject) => {
        api
          .uploadUnrulyPax(archiveFile, rootGetters.currentTenant)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
    setUnrulyPaxListPagination({ commit }, pagination) {
      commit('setUnrulyPaxListPagination', pagination)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/unruly-pax.js